import { Icon, IconProps } from "../Icon";

const Restart = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25 18C25 23.5228 20.5228 28 15 28C9.47715 28 5 23.5228 5 18C5 12.4772 9.47715 8 15 8H21.18L17.6 11.59L19 13L25 7L19 1L17.6 2.41L21.19 6H15C8.37258 6 3 11.3726 3 18C3 24.6274 8.37258 30 15 30C21.6274 30 27 24.6274 27 18H25Z"
      fill="currentColor"
    />
  </Icon>
);

export default Restart;
